
<div class="side-nav-content">
  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ lang === 'en' ? "Trips" : "الرحلات" }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <ul>
      <li>
        <a mat-button routerLink="upcoming-trips" routerLinkActive="active" class="de-active">
          {{lang === 'en' ? "Upcoming Trips" : "الرحلات القادمة"}}
        </a>
      </li>
      <li>
        <a mat-button routerLink="book-history" routerLinkActive="active" class="de-active">
          {{ lang === 'en' ? "Book History" : "سجل الحجوزات" }}
        </a>
      </li>
    </ul>
  </mat-expansion-panel>
  
  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ lang === 'en' ? "Settings" : "الإعدادات" }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <ul>
      <li>
        <a mat-button routerLink="userProfile" routerLinkActive="active" class="de-active">
          {{lang === 'en' ? "Profile" : "الملف الشخصي"}}
        </a>
      </li>
    </ul>
  </mat-expansion-panel>
</div>